/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DayInput
 */
export interface DayInput {
    /**
     * 
     * @type {string}
     * @memberof DayInput
     */
    day?: string;
}

/**
 * Check if a given object implements the DayInput interface.
 */
export function instanceOfDayInput(value: object): value is DayInput {
    return true;
}

export function DayInputFromJSON(json: any): DayInput {
    return DayInputFromJSONTyped(json, false);
}

export function DayInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayInput {
    if (json == null) {
        return json;
    }
    return {
        
        'day': json['day'] == null ? undefined : json['day'],
    };
}

export function DayInputToJSON(json: any): DayInput {
    return DayInputToJSONTyped(json, false);
}

export function DayInputToJSONTyped(value?: DayInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': value['day'],
    };
}

